var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#DFF6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3752 39.9163H33.6252C38.8335 39.9163 40.9168 37.833 40.9168 32.6247V26.3747C40.9168 21.1663 38.8335 19.083 33.6252 19.083H27.3752C22.1668 19.083 20.0835 21.1663 20.0835 26.3747V32.6247C20.0835 37.833 22.1668 39.9163 27.3752 39.9163Z",
    stroke: "#47B5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3748 27.4167C28.5254 27.4167 29.4582 26.4839 29.4582 25.3333C29.4582 24.1827 28.5254 23.25 27.3748 23.25C26.2242 23.25 25.2915 24.1827 25.2915 25.3333C25.2915 26.4839 26.2242 27.4167 27.3748 27.4167Z",
    stroke: "#47B5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7812 36.7393L25.9167 33.2913C26.7396 32.7393 27.9271 32.8018 28.6667 33.4372L29.0104 33.7393C29.8229 34.4372 31.1354 34.4372 31.9479 33.7393L36.2812 30.0205C37.0937 29.3226 38.4062 29.3226 39.2187 30.0205L40.9167 31.4788",
    stroke: "#47B5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryPlaceholder);
export default __webpack_public_path__ + "static/media/category_placeholder.790be2a0f5eac259248296f005bb7369.svg";
export { ForwardRef as ReactComponent };